var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCicleError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28564 11.7138C3.54476 12.9733 5.21924 13.6666 6.99984 13.6666C8.78044 13.6666 10.4549 12.9733 11.714 11.7138C14.313 9.11456 14.313 4.8854 11.714 2.28611C10.4549 1.02667 8.78044 0.333313 6.99984 0.333313C5.21924 0.333313 3.54476 1.02667 2.28564 2.28611C-0.313314 4.8854 -0.313314 9.11456 2.28564 11.7138ZM7.00012 0.99998C8.60298 0.99998 10.1095 1.624 11.243 2.75747C13.5821 5.09666 13.5821 8.9033 11.243 11.2425C10.1095 12.376 8.60298 13 7.00012 13C5.39725 13 3.89074 12.376 2.75728 11.2425C0.418085 8.9033 0.418085 5.09666 2.75728 2.75747C3.89074 1.624 5.39725 0.99998 7.00012 0.99998ZM4.40702 9.92609C4.32173 9.92609 4.23644 9.89353 4.17134 9.82843C4.04113 9.69822 4.04113 9.48728 4.17134 9.35708L6.52815 6.99998L4.17134 4.64288C4.04113 4.51267 4.04113 4.30174 4.17134 4.17153C4.30155 4.04132 4.51249 4.04132 4.64269 4.17153L6.99947 6.52858L9.35624 4.17153C9.48645 4.04132 9.69738 4.04132 9.82759 4.17153C9.9578 4.30174 9.9578 4.51267 9.82759 4.64288L7.47078 6.99998L9.82759 9.35708C9.9578 9.48728 9.9578 9.69822 9.82759 9.82843C9.76249 9.89353 9.6772 9.92609 9.59191 9.92609C9.50663 9.92609 9.42134 9.89353 9.35624 9.82843L6.99947 7.47137L4.64269 9.82843C4.57759 9.89353 4.4923 9.92609 4.40702 9.92609Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCicleError);
export default __webpack_public_path__ + "static/media/ic_cicle_error.55a77d710c74e9f6b12f4fe03eb3fde8.svg";
export { ForwardRef as ReactComponent };